export default "__VITE_ASSET__BSSWlfSc__"